enum AssetTypes {
  Video = "Video",
  Survey = "Survey",
  Assessment = "Assessment",
  Pdf = "Pdf",
  EmbeddedVideo = "EmbeddedVideo",
  Link = "Link",
  Scorm = "Scorm",
}
export default AssetTypes;
